<template lang="pug">
  .card
    header.card-header
      p.card-header-title
        | {{ `Cotización ${dataCotizacion.id_cotizacion}` }}
      a.button.is-black.is-rounded.is-small(@click='hideData')
        span.icon
          i.fas.fa-times
    .card-content
      .columns.has-text-left
        .column.is-12
          p.subtitle Descripción: 
            small {{ dataCotizacion.descripcion }}
          span.tag.is-black Importe Cotizacion: {{ dataCotizacion.total | currency }}
      hr.navbar-divider
      .columns.has-text-left
        .column.is-12
          div
            p.has-text-grey.is-size-6
            small
              b.has-text-grey-darker Proveedor Seleccionado:&nbsp
            | {{ dataCotizacion.nombreProveedor }}&nbsp
            a.button.is-danger.is-rounded.is-small(:href='getFile(dataCotizacion.file)')
              span.icon
                i.fas.fa-file-pdf
      .columns.has-text-left
        .column.is-12
          div(v-for='(i, index) in dataCotizacion.items' v-show="i.id_proveedor !== dataCotizacion.id_proveedor")
            p.has-text-grey.is-size-6
            small
              b.has-text-grey-darker {{`Proveedor ${index + 1}`}}:&nbsp
            | {{i.nombreProveedor }}&nbsp
            a.button.is-danger.is-rounded.is-small(:href='getFile(i.rutaFile)')
              span.icon
                i.fas.fa-file-pdf
      hr.navbar-divider
      .columns.has-text-left
        .column.is-12
          div(v-for='(a, index) in dataCotizacion.articulos')
            p.has-text-grey.is-size-6
              b.has-text-grey-darker {{`#${index + 1}`}}:&nbsp
              small
              | {{a.descripcion }}&nbsp
            div.field.is-grouped
              div.control
                div.tags.has-addons
                  span.tag.is-primary 
                    b Cant.
                  span.tag 
                    b {{ a.cant }}
              div.control
                div.tags.has-addons
                  span.tag.is-primary
                    b P. U.
                  span.tag 
                    b {{ a.precioUnit | currency }}
              div.control
                div.tags.has-addons
                  span.tag.is-black 
                    b Importe.
                  span.tag 
                    b {{ a.importe | currency }}
            br
</template>

<script>
  export default {
    name: 'CardDataCot',
    props: {
      dataCotizacion: {
        type: Object,
        default: () => {}
      },
    },
    methods: {
      hideData() {
        this.$emit('hideCotData', true)
      },
      getFile(file) {
        const currentUrl = window.location.href
        return `https://${currentUrl}${file}`
      }
    },
    
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/presupuestos_Componentes/componentes/CardDataCot.vue